	
(function ( $ ) {
 	"use strict";
	
    $.fn.cstmFormatPhonenumber = function( options ) {
 		
		var config	= {
			isInitializedClassName: 'cstm-phonenumber-formatter-initialized'
		};
		
		// have default options.
        var settings = $.extend({
            selector:		".cstm-phonenumber-formatter",
            expression: /[^\+0-9-\(\)\/ ]/g,
			defaultEvents:	'input blur',
			removeDoubleChars : true,
        }, options );
		
		this.each( function() {
			
			var elem = $( this );
			
			// bind events
			if( !elem.hasClass(config.isInitializedClassName+'-events') ) {
				elem.bind(settings.defaultEvents, function() {
					$(settings.selector).cstmFormatPhonenumber( settings );
				}).addClass(config.isInitializedClassName+'-events');
			}
			
			var elemValue = elem.val().toString().toLowerCase();
			var formatted = elemValue.replace(settings.expression, "");
			
			// kick out double signs
			if(settings.removeDoubleChars) {
				formatted = formatted.replace(/ +/g, " ");
				formatted = formatted.replace(/-+/g, "-");
				formatted = formatted.replace(/\/+/g, "/");
				formatted = formatted.replace(/\(+/g, "(");
				formatted = formatted.replace(/\)+/g, ")");
			}
			
			elem.val(formatted);
			
        });
				  
 		return this;
    };
 
}(jQuery));
